export default "__VITE_ASSET__faa31309__"